<template>

    <section id='hp-warranty'>
        <div class="container" v-if="is_pl">
            <div id="warranty-stamp"></div>
            <div id="warranty-info">
                <p v-translate="'pg_warranty'"></p>
                <p><a class='btn white' :href="getWarrantyLink()" v-translate="'pg_warranty_l'"></a></p>
            </div>
        </div>
    </section>

</template>
<script>
import SerieLogo from '../Graphics/SerieLogo';
import SerieSymbol from '../Graphics/SerieSymbol';

  export default {
    name: 'HomePageWarranty',
    components: {
      SerieLogo,
      SerieSymbol
    },
      data() {
          return {
              is_pl: env.language === 'pl'
          }
      },
    methods: {
      getWarrantyLink() {
        return window.env.baseUrl + window.translations['rt_warranty'];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomePage/Warranty.vue